import React from 'react';

const ExperimentContext = React.createContext({
  experiments: {}
});

export default ExperimentContext;



// WEBPACK FOOTER //
// ./src/universal/components/Experiment/ExperimentContext.js